
import { Card, Col, Row } from 'react-bootstrap';
import SmashPrice from '../../../components/SmashPrice/SmashPrice';
import SmashSpinner from '../../../components/SmashSpinner/SmashSpinner';
import { usePlanUsage } from '../hooks/usePlanUsage';
import PlanCancelModal from './PlanCancelModal';

const PlanRecap = () => {

    const [isPlanUsageLoading, planUsageDisplay] = usePlanUsage();

    return (
        <Card className="my-3">
            <Card.Header as="h5">
                <Row>
                    <Col className="hstack gap-3 d-flex align-items-center">
                        Subscription
                    </Col>
                    <Col className="hstack gap-3 d-flex justify-content-end align-items-center">
                        <PlanCancelModal />
                    </Col>
                </Row>
            </Card.Header>
            <Card.Body>
                {isPlanUsageLoading && <SmashSpinner />}
                {planUsageDisplay && !isPlanUsageLoading && <>
                    <p><strong>Plan: </strong>{planUsageDisplay.plan} ({planUsageDisplay.dataUsageLimitFormat})</p>
                    <p><strong>Price: </strong><SmashPrice price={planUsageDisplay.price} currency={planUsageDisplay.currency}></SmashPrice></p>
                    {planUsageDisplay.status === 'Active' && <p><strong>Subscription will {planUsageDisplay.automaticRenew ? 'renew' : 'end'} on: </strong> {planUsageDisplay.endDate}</p>}
                    {planUsageDisplay.status !== 'Active' && <p><strong>Your subscription has ended on {planUsageDisplay.endDate}</strong></p>}
                </>}
            </Card.Body>
        </Card>
    )
}

export default PlanRecap